import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { XThemeContainer } from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { Row, Col, Skeleton, Badge } from 'antd';
import Header from '../../components/Header/Header';
import {
	ParaShieldLeftScrollWrapper2,
	XThemeFitToScreen,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVSGenerateAL,
	XThemeVSScrollContainer,
	XThemeVSSetViewPort,
	XVSLottie,
} from './VoiceAssistanceStyle';
import MainChat from './Components/Responsive/MainChat';
import UnifiedChat from './Components/UnifiedChat';
import { getCasesApi, getCasesReset } from '../../actions/getCasesAction';
import { getUserProfile, getUserName, getUserId } from '../../utils/helper';
import config from '../../config';
import moment from 'moment';
import VATable from './Components/CaseList/VATable';
import VACaseAnalysisController from './Components/CaseAnalysis/VACaseAnalysisController';
import VAAppealLetterController from './Components/AppealLetter/VAAppealLetterController';
import VABatchController from './Components/BatchProcessing/VABatchController';
import VACaseTimelineController from './Components/CaseAnalysis/VACaseTImeline/VACaseTimelineController';
import { editCaseApi, editCaseReset } from '../../actions/editCaseAction';
import VAInitailBatchLoader from './Components/BatchProcessing/VAInitailBatchLoader';
import InitialBatchLoader from '../../json/case_allocation_reclaim.json';
import { XLottieLetter } from '../AnalyseCoverage/AnalyseCoverageStyle';
import AppealLoading from '../../json/Reclaim.json';
import {
	XChartControlsContainer,
	XChartDropdown,
	XLottieShieldMaxx,
	XShieldRightScrollCard,
	XShieldSpiderCard,
} from '../ShieldMaxx/ShieldMaxxStyle';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';
import { PlusSquareOutlined } from '@ant-design/icons';
import SpiderChart from '../../components/Chart/SpiderChart';
import PayerComparison from './Components/PayerComparison/PayerComparison';
import VAPayerComparisonController from './Components/PayerComparison/VAPayerComparisonController';
import Default from './Components/Responsive/Default';
import MobileChat1 from './Components/Responsive/MobileChat1';
import MobileChat5 from './Components/Responsive/MobileChat5';
import MobileChat7 from './Components/Responsive/MobileChat7';
import MobileChat8 from './Components/Responsive/MobileChat8';

const VoiceAssistance = (props) => {
	const { editCase, editCaseReset } = props;
	const { casesData, casesApiState } = props;
	const { conversationId } = useParams();
	const navigate = useNavigate();
	const [action, setAction] = useState(null);
	const [actionParameters, setActionParameters] = useState(null);
	const [actionComponent, setActionComponent] = useState(null);
	const [processingAction, setProcessingAction] = useState(false);
	const [initialLoadComplete, setInitialLoadComplete] = useState(false);
	const [userInfo, setUserInfo] = useState({
		name: '',
		profile: '',
		id: '',
	});
	const [skipInitialApiCall, setSkipInitialApiCall] = useState(false);
	const [pendingUserInput, setPendingUserInput] = useState(null);
	const [chatStarted, setChatStarted] = useState(false);
	const [recentMessages, setRecentMessages] = useState([]);

	// Get greeting based on time of day
	const getGreeting = () => {
		const currentHour = moment().hour();

		if (currentHour >= 5 && currentHour < 12) {
			return 'Good Morning';
		} else if (currentHour >= 12 && currentHour < 17) {
			return 'Good Afternoon';
		} else {
			return 'Good Evening';
		}
	};

	useEffect(() => {
		// If we have a conversationId in URL, skip the initial API call
		// as we'll load conversation-specific data instead
		if (conversationId) {
			setSkipInitialApiCall(true);
			setChatStarted(true);
		} else {
			// When conversationId is removed (back button), reset states
			setSkipInitialApiCall(false);
			setChatStarted(false);
		}

		// Get user information
		const userName = getUserName();
		const userProfileImg = getUserProfile();
		const userId = getUserId();

		setUserInfo({
			name: userName || 'User',
			profile:
				userProfileImg &&
				userProfileImg !== 'undefined' &&
				userProfileImg !== ''
					? `${config.s3_url}${userProfileImg}`
					: '/images/prifile.svg',
			id: userId,
		});

		// Set initialLoadComplete to true after the component mounts
		setInitialLoadComplete(true);
	}, [conversationId]);

	// Shared skeleton component for both initial load and action processing
	const renderSkeleton = () => (
		// <XThemeVoiceAssTableCard>
		// 	<div className="hasPadding">
		// 		<Row>
		// 			<Col xs={12}>
		// 				<Skeleton.Input style={{ width: 120 }} active />
		// 			</Col>
		// 			<Col xs={12} className="text-end">
		// 				<Skeleton.Input style={{ width: 180 }} active />
		// 			</Col>
		// 		</Row>
		// 	</div>
		// 	<div className="tableWrapper" style={{ padding: '20px' }}>
		// 		<Skeleton active paragraph={{ rows: 6 }} />
		// 	</div>
		// </XThemeVoiceAssTableCard>
		<XThemeVSGenerateAL className="h-100">
			<XVSLottie
				className="relativePositions"
				animationData={InitialBatchLoader}
				loop={true}
			/>
		</XThemeVSGenerateAL>
	);

	// Handle conversation URL updates
	const handleConversationChange = (conversationId) => {
		// Set a flag to prevent default API call during navigation
		if (conversationId) {
			setSkipInitialApiCall(true);
			navigate(`/agent-maxx/${conversationId}`);
		} else {
			// Only for new chat do we allow the default API call
			setSkipInitialApiCall(false);
			navigate('/agent-maxx');
		}
	};

	const handleActionReceived = (actionType, params, component) => {
		// Reset the current action first to ensure the effect triggers even if
		// the same action comes again
		setAction(null);
		setActionParameters(null);
		setActionComponent(null);

		// If action is null, just clear the state without triggering any action
		if (!actionType) {
			return;
		}

		console.log('Action received:', actionType, params, component);
		// Log the received action for debugging

		// Use setTimeout to ensure state updates have propagated
		setTimeout(() => {
			setAction(actionType);
			setActionParameters(params);
			setActionComponent(component);
			setProcessingAction(true);
		}, 10);

		switch (actionType) {
			case 'upload_supporting_document':
				// Implement the document upload logic
				if (params?.id && params?.supporting_docs) {
					setProcessingAction(true);
					editCase({
						id: params.id,
						supporting_docs: params.supporting_docs,
						upload_documents: true,
					});
					setActionComponent('data_table'); // Return to the data table view after upload
				}
				break;
			default:
				// Default to VATable if component type is not recognized
				//setActionComponent('default');
				setProcessingAction(false);
		}
	};

	// Helper function to render the appropriate component based on component type
	const renderComponentByType = () => {
		// When we're processing but don't have the action yet, show skeleton
		if (processingAction && !action) {
			return renderSkeleton();
		}

		console.log('Action component:', actionComponent);
		console.log('Action:', action);
		console.log('Action parameters:', actionParameters);
		// When no specific component type is specified or default case
		if (!actionComponent || actionComponent === 'default') {
			return (
				// <Row className="my-4">
				// 	<Col
				// 		xs={{ span: 12, offset: 6 }}
				// 		sm={{ span: 6, offset: 9 }}
				// 		className="text-center mb-4"
				// 	>
				// 		<XLottieLetter
				// 			animationData={AppealLoading}
				// 			loop={true}
				// 		/>
				// 	</Col>
				// 	<Col xs={24} className="text-center">
				// 		<div className="asistCardTitle">
				// 			{getGreeting()}, {userInfo.name}! <br />
				// 			How can I assist you today?
				// 		</div>
				// 	</Col>
				// </Row>
				<XThemeVSGenerateAL className="h-100">
					<XVSLottie
						className="relativePositions"
						animationData={InitialBatchLoader}
						loop={true}
					/>
				</XThemeVSGenerateAL>
			);
		}

		// Handle different component types
		switch (actionComponent) {
			case 'data_table':
				return (
					<VATable
						action={action}
						actionParameters={actionParameters}
						casesData={casesData}
						initialLoad={
							initialLoadComplete &&
							!action &&
							!skipInitialApiCall
						}
						greeting={getGreeting()}
						userInfo={userInfo}
						setProcessingAction={setProcessingAction}
					/>
				);
			case 'data_table_list':
				return (
					<VATable
						action={action}
						actionParameters={actionParameters}
						casesData={casesData}
						initialLoad={
							initialLoadComplete &&
							!action &&
							!skipInitialApiCall
						}
						greeting={getGreeting()}
						userInfo={userInfo}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'case_analysis':
				return (
					<VACaseAnalysisController
						action={action}
						actionParameters={actionParameters}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'appeal_letter':
				return (
					<VAAppealLetterController
						action={action}
						actionParameters={actionParameters}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'revenue_cycle_management':
				return (
					<VACaseAnalysisController
						action={action}
						actionParameters={actionParameters}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'document_uploader':
				return (
					<VATable
						action={action}
						actionParameters={actionParameters}
						casesData={casesData}
						initialLoad={
							initialLoadComplete &&
							!action &&
							!skipInitialApiCall
						}
						greeting={getGreeting()}
						userInfo={userInfo}
						setProcessingAction={setProcessingAction}
						onActionReceived={handleActionReceived}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'case_creation':
				return (
					<VATable
						action={action}
						actionParameters={actionParameters}
						casesData={casesData}
						initialLoad={
							initialLoadComplete &&
							!action &&
							!skipInitialApiCall
						}
						greeting={getGreeting()}
						userInfo={userInfo}
						setProcessingAction={setProcessingAction}
						onActionReceived={handleActionReceived}
						onUserInputRequired={handleUserInputRequired}
					/>
				);
			case 'batches':
				return (
					<VABatchController
						action={action}
						actionParameters={actionParameters}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
						onActionReceived={handleActionReceived}
						recentMessages={recentMessages}
						activeConversationId={conversationId}
					/>
				);
			case 'payer_score_card':
				return (
					<VAPayerComparisonController
						action={action}
						actionParameters={actionParameters}
						setProcessingAction={setProcessingAction}
						onUserInputRequired={handleUserInputRequired}
						onActionReceived={handleActionReceived}
						recentMessages={recentMessages}
					/>
				);
			default:
				// Default to VATable if component type is not recognized
				return (
					// <Row className="my-4">
					// 	<Col
					// 		xs={{ span: 12, offset: 6 }}
					// 		sm={{ span: 6, offset: 9 }}
					// 		className="text-center mb-4"
					// 	>
					// 		<XLottieLetter
					// 			animationData={AppealLoading}
					// 			loop={true}
					// 		/>
					// 	</Col>
					// 	<Col xs={24} className="text-center">
					// 		<div className="asistCardTitle">
					// 			{getGreeting()}, {userInfo.name}! <br />
					// 			How can I assist you today?
					// 		</div>
					// 	</Col>
					// </Row>
					<XThemeVSGenerateAL className="h-100">
						<XVSLottie
							className="relativePositions"
							animationData={InitialBatchLoader}
							loop={true}
						/>
					</XThemeVSGenerateAL>
				);
		}
	};

	// Add this function to handle user input requests from child components
	const handleUserInputRequired = (userInputRequest) => {
		console.log('User input required received:', userInputRequest);

		if (userInputRequest === null || userInputRequest?.clear_user_input) {
			setPendingUserInput(null);
		} else if (userInputRequest?.response_type === 'action') {
			// Handle action-based requests (like case-detail)
			console.log('Handling action request:', userInputRequest);
			console.log('Setting action to:', userInputRequest.action);
			console.log('Setting component to:', userInputRequest.component);
			setAction(userInputRequest.action);
			setActionParameters(userInputRequest.parameters);
			setActionComponent(userInputRequest.component);
			setProcessingAction(true);
		} else {
			console.log('Setting user input');
			console.log('userInputRequest filled', userInputRequest);
			setPendingUserInput(userInputRequest);
		}
	};

	// Todo use this in VATableController.js
	// When the API completes, set processingAction to false
	useEffect(() => {
		if (processingAction) {
			setProcessingAction(false);
		}
	}, [casesApiState]);

	const handleMessagesChange = (messages) => {
		setRecentMessages(messages);
	};

	// Handle dropdown changes

	// Add state for 3 dropdowns with status colors
	const [selectedPayer, setSelectedPayer] = useState('all');
	const [selectedMetric, setSelectedMetric] = useState('performance');
	const [selectedTimeframe, setSelectedTimeframe] = useState('current');

	const handlePayerChange = (value) => {
		setSelectedPayer(value);
	};

	const handleMetricChange = (value) => {
		setSelectedMetric(value);
	};

	const handleTimeframeChange = (value) => {
		setSelectedTimeframe(value);
	};

	// Status color mapping
	const getStatusColor = (value, type) => {
		const statusMap = {
			payer: {
				all: 'blue',
				payerA: 'green',
				payerB: 'orange',
				payerC: 'red',
			},
			metric: {
				performance: 'green',
				financial: 'blue',
				operational: 'purple',
			},
			timeframe: {
				current: 'green',
				quarter: 'orange',
				year: 'blue',
				ytd: 'purple',
			},
		};
		return statusMap[type]?.[value] || 'default';
	};
	// Enhanced dropdown options with status indicators
	const dropdownOptions = {
		payer: [
			{
				value: 'all',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('all', 'payer')} />
						All Payers
					</div>
				),
			},
			{
				value: 'payerA',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('payerA', 'payer')} />
						Payer A
					</div>
				),
			},
			{
				value: 'payerB',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('payerB', 'payer')} />
						Payer B
					</div>
				),
			},
			{
				value: 'payerC',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('payerC', 'payer')} />
						Payer C
					</div>
				),
			},
		],
		metric: [
			{
				value: 'performance',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge
							color={getStatusColor('performance', 'metric')}
						/>
						Performance
					</div>
				),
			},
			{
				value: 'financial',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('financial', 'metric')} />
						Financial
					</div>
				),
			},
			{
				value: 'operational',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge
							color={getStatusColor('operational', 'metric')}
						/>
						Operational
					</div>
				),
			},
		],
		timeframe: [
			{
				value: 'current',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('current', 'timeframe')} />
						Current Month
					</div>
				),
			},
			{
				value: 'quarter',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('quarter', 'timeframe')} />
						Last Quarter
					</div>
				),
			},
			{
				value: 'year',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('year', 'timeframe')} />
						Last Year
					</div>
				),
			},
			{
				value: 'ytd',
				label: (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<Badge color={getStatusColor('ytd', 'timeframe')} />
						Year to Date
					</div>
				),
			},
		],
	};

	// Spider chart data matching video format exactly
	const spiderChartDataSets = {
		performance: {
			labels: [
				'Pre-service',
				'Post Claim',
				'Appeals',
				'Denials',
				'Recovery',
				'Efficiency',
			],
			datasets: {
				all: [
					{
						label: 'Payer A',
						data: [85, 70, 60, 45, 80, 75],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: false,
					},
					{
						label: 'Payer B',
						data: [65, 85, 75, 60, 70, 80],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: false,
					},
					{
						label: 'Payer C',
						data: [90, 60, 80, 70, 65, 85],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: false,
					},
				],
				payerA: [
					{
						label: 'Payer A',
						data: [85, 70, 60, 45, 80, 75],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: true,
					},
				],
				payerB: [
					{
						label: 'Payer B',
						data: [65, 85, 75, 60, 70, 80],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: true,
					},
				],
				payerC: [
					{
						label: 'Payer C',
						data: [90, 60, 80, 70, 65, 85],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: true,
					},
				],
			},
		},
		financial: {
			labels: [
				'Revenue',
				'Costs',
				'Profit Margin',
				'ROI',
				'Cash Flow',
				'Growth',
			],
			datasets: {
				all: [
					{
						label: 'Payer A',
						data: [75, 60, 85, 70, 80, 65],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: false,
					},
					{
						label: 'Payer B',
						data: [80, 55, 90, 75, 85, 70],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: false,
					},
					{
						label: 'Payer C',
						data: [70, 65, 80, 60, 75, 80],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.1)',
						borderWidth: 3,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: false,
					},
				],
				payerA: [
					{
						label: 'Payer A',
						data: [75, 60, 85, 70, 80, 65],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: true,
					},
				],
				payerB: [
					{
						label: 'Payer B',
						data: [80, 55, 90, 75, 85, 70],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: true,
					},
				],
				payerC: [
					{
						label: 'Payer C',
						data: [70, 65, 80, 60, 75, 80],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.15)',
						borderWidth: 3,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: true,
					},
				],
			},
		},
		operational: {
			labels: [
				'Processing Time',
				'Accuracy',
				'Compliance',
				'Customer Satisfaction',
				'Innovation',
				'Scalability',
			],
			datasets: {
				all: [
					{
						label: 'Payer A',
						data: [80, 85, 90, 75, 70, 80],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.15)',
						borderWidth: 4,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: true,
					},
					{
						label: 'Payer B',
						data: [85, 80, 85, 80, 75, 85],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.15)',
						borderWidth: 4,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: true,
					},
					{
						label: 'Payer C',
						data: [75, 90, 80, 85, 80, 75],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.15)',
						borderWidth: 4,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: true,
					},
				],
				payerA: [
					{
						label: 'Payer A',
						data: [80, 85, 90, 75, 70, 80],
						borderColor: '#4A90E2',
						backgroundColor: 'rgba(74, 144, 226, 0.2)',
						borderWidth: 4,
						pointBackgroundColor: '#4A90E2',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#4A90E2',
						fill: true,
					},
				],
				payerB: [
					{
						label: 'Payer B',
						data: [85, 80, 85, 80, 75, 85],
						borderColor: '#50C878',
						backgroundColor: 'rgba(80, 200, 120, 0.2)',
						borderWidth: 4,
						pointBackgroundColor: '#50C878',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#50C878',
						fill: true,
					},
				],
				payerC: [
					{
						label: 'Payer C',
						data: [75, 90, 80, 85, 80, 75],
						borderColor: '#FF6B6B',
						backgroundColor: 'rgba(255, 107, 107, 0.2)',
						borderWidth: 4,
						pointBackgroundColor: '#FF6B6B',
						pointBorderColor: '#fff',
						pointHoverBackgroundColor: '#fff',
						pointHoverBorderColor: '#FF6B6B',
						fill: true,
					},
				],
			},
		},
	};

	// Get current chart data based on selections
	const currentMetricData = spiderChartDataSets[selectedMetric];
	const spiderChartData = {
		labels: currentMetricData.labels,
		datasets: currentMetricData.datasets[selectedPayer],
	};
	return (
		<>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header headerTag="RevMaxx Assistance" />
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile />
				</Col>
			</>

			{/* Todo: Add showDesktop hide chat for mobile */}

			<XThemeContainer fluid>
				<ParaShieldLeftScrollWrapper2>
					<Row gutter={[15, 15]}>
						<Col
							xs={24}
							sm={24}
							md={chatStarted ? 8 : 24}
							lg={chatStarted ? 8 : 24}
						>
							<UnifiedChat
								chatStarted={chatStarted}
								setChatStarted={setChatStarted}
								onActionReceived={handleActionReceived}
								isProcessingAction={processingAction}
								greeting={getGreeting()}
								userInfo={userInfo}
								onConversationChange={handleConversationChange}
								initialConversationId={conversationId}
								pendingUserInput={pendingUserInput}
								setPendingUserInput={setPendingUserInput}
								onMessagesChange={handleMessagesChange}
							/>
						</Col>
						{chatStarted && actionComponent ? (
							<Col xs={24} sm={24} md={16} lg={16}>
								<div className="header leftHeaderData">
									<Row gutter={[15, 15]}>
										<Col xs={24} className="mb-3">
											<XThemeVoiceAssTitle>
												{getGreeting()}, {userInfo.name}
												!
											</XThemeVoiceAssTitle>
										</Col>
									</Row>
								</div>
								<div className="leftScrollData RightScrollData">
									{renderComponentByType()}
								</div>
							</Col>
						) : !actionComponent && chatStarted ? (
							<Col xs={24} sm={24} md={16} lg={16}>
								{renderComponentByType()}
							</Col>
						) : null}
					</Row>
				</ParaShieldLeftScrollWrapper2>
			</XThemeContainer>

			{/* //Todo: Add mobile chat */}

			{/* <div className="showMobile">
				<Row>
					<Col xs={24}>
						<MainChat
							chatStarted={chatStarted}
							setChatStarted={setChatStarted}
							onActionReceived={handleActionReceived}
							isProcessingAction={processingAction}
							greeting={getGreeting()}
							userInfo={userInfo}
							onConversationChange={handleConversationChange}
							initialConversationId={conversationId}
							pendingUserInput={pendingUserInput}
							setPendingUserInput={setPendingUserInput}
						/>
						<MobileChat1 />
					</Col>
				</Row>
			</div> */}
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		casesData: state.getCases.data,
		casesApiState: state.getCases.apiState,
		casesError: state.getCases.error,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getCases: (data) => dispatch(getCasesApi(data)),
		getCasesReset: () => dispatch(getCasesReset()),
		editCase: (params) => dispatch(editCaseApi(params)),
		editCaseReset: () => dispatch(editCaseReset()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(VoiceAssistance);
